import { render, staticRenderFns } from "./Caozuoshouce.vue?vue&type=template&id=4b5a11b0&scoped=true"
import script from "./Caozuoshouce.vue?vue&type=script&lang=js"
export * from "./Caozuoshouce.vue?vue&type=script&lang=js"
import style0 from "./Caozuoshouce.vue?vue&type=style&index=0&id=4b5a11b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5a11b0",
  null
  
)

export default component.exports